import type { Thread, Reply } from '../domains/model';

export function addReplyToThread(threads: Array<Thread>, reply: Reply): Array<Thread> {
  return threads.map((comment) => {
    if (comment.id === reply.threadId) {
      comment.replies.push(reply);
    }

    return comment;
  });
}

export function removeReplyFromThread(threads: Array<Thread>, reply: Reply): Array<Thread> {
  return threads.map((thread) => ({
    ...thread,
    replies: thread.replies.filter((commentReply) => commentReply.id !== reply.id),
  }));
}

export function updateReplyInThread(threads: Array<Thread>, reply: Reply): Array<Thread> {
  return threads.map((thread) => {
    return {
      ...thread,
      replies: thread.replies.map((oldReply) => (oldReply.id === reply.id ? reply : oldReply)),
    };
  });
}
